<mat-dialog-content>
  @if (asset.type == 'Still') {
    <img
      [src]="getLinkImage(asset.reviewUri) | secure | async"
      [hidden]="!isImageLoaded"
      (load)="loadImage()"
      />
  }
  @if (asset.type != 'Still') {
    <video
      controls
      autoplay="1"
      [src]="getLinkImage(asset.reviewUri) | secure | async"
    ></video>
  }

  @if (asset.type == 'Still') {
    <div class="asset-actions">
      <button mat-icon-button (click)="fullscreen = true">
        <mat-icon> fullscreen </mat-icon>
      </button>
    </div>
  }
</mat-dialog-content>
@if (data.type != 'outputAssets') {
  <mat-dialog-actions style="height: 90px">
    <button
      mat-icon-button
      color="white"
      class="action_button"
      (click)="previousAsset()"
      >
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <span class="spacer"></span>
    @if (state == null || state == EStateAsset.REJECTED) {
      <button
        mat-icon-button
        color="error"
        class="action_button"
        (click)="onReview(EStateAsset.REJECTED)"
        >
        <mat-icon>cancel</mat-icon>
      </button>
    }
    @if (state == EStateAsset.APPROVED) {
      <button
        mat-icon-button
        color="Required"
        class="action_button"
        (click)="onReview(null)"
        >
        <mat-icon>highlight_remove</mat-icon>
      </button>
    }
    <button
      mat-icon-button
      color="white"
      class="action_button"
      (click)="openReview()"
      >
      <mat-icon>rate_review</mat-icon>
    </button>
    @if (state == null || state == EStateAsset.APPROVED) {
      <button
        mat-icon-button
        color="success"
        class="action_button"
        (click)="onReview(EStateAsset.APPROVED)"
        >
        <mat-icon>check_circle</mat-icon>
      </button>
    }
    @if (state == EStateAsset.REJECTED) {
      <button
        mat-icon-button
        color="Required"
        class="action_button"
        (click)="onReview(null)"
        >
        <mat-icon>highlight_remove</mat-icon>
      </button>
    }
    <span class="spacer"></span>
    <button
      mat-icon-button
      color="white"
      class="action_button"
      (click)="nextAsset()"
      >
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  </mat-dialog-actions>
}

@if (fullscreen) {
  <app-review-fullscreen
    [currentAsset]="getLinkImage(asset.reviewUri)"
    (exit)="fullscreen = false"
  ></app-review-fullscreen>
}
